<template>
  <div class="headerBg">
    <div class="header layout">
      <a href="//www.med66.com/" target="_blank" class="logo fl" title="医学教育网">
        <img src="//www.med66.com/images/2017lammu_logo.png" alt="医学教育网">
      </a>
      <div id="titleName">
        <div class="mstit">在线模拟考试系统</div>
      </div>
      <!--登录-->
      <div class="right fr" >
        <div class="right-login fl" id="noLogin" v-if="!isShowLogin">
          <a href="javascript:void(0)" class="dzhan fl ucLoginBtn" title="学员登录">登录</a>
          <a href="javascript:void(0)" class="dzhan fl ucRegisterBtn" title="学员注册">注册</a>
        </div>
        <div class="right-loginh fl pr h-an qp" id="yesLogin" style="z-index: 15;" v-else>
          <span class="ctxt">
              <i class="xquan abs"></i>
              <img :src="iconUrl" alt="">
          </span>
          <i class="xian abs"></i>
          <div class="pop3 clearfix abs">
            <div class="pop3-t clearfix">
              <div class="pop3-t-l fl" id="loginIconUrl">
                <a href="//member.med66.com/home/index.html#/user/myinfo/1" target="_blank">
                  <i class="dquan abs"></i>
                  <img :src="iconUrl" alt="">
                </a>
              </div>
              <div class="pop3-t-r fl">
                <p id="loginName">184···6683</p>
              </div>
            </div>
            <div class="pop3-c clearfix">
              <a href="//member.med66.com/mycenter/index.shtm" target="_blank" class="chan fl h-an" title="我的课程">我的课程</a>
              <a href="//member.med66.com/home/index.html#/user/myinfo/1" target="_blank" class="chan chan2 fl h-an" title="个人资料">个人资料</a>
            </div>
            <a href="javascript:void(0)" class="pop3-b ucLogoutBtn" title="退出" @click="logout">退 出</a>
          </div>
        </div>
      </div>
      <div class="cen fr">
        <a href="//www.med66.com/" target="_blank" class="cen-n02 fl" title="医学教育网首页">首页</a>
        <a href="//www.med66.com/webhtml/project/" target="_blank" class="cen-n02 fl" title="医学教育网辅导课程招生方案">招生方案</a>
        <a href="//www.med66.com/webhtml/demo/" target="_blank" class="cen-n02 fl" title="医学教育网辅导课程免费试听">免费试听</a>
        <a href="//www.med66.com/webhtml/teacher/" target="_blank" class="cen-n02 fl" title="医学教育网辅导名师">网校老师</a>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'CommonHeader',
    data(){
      return{
        iconUrl:'',
        isShowLogin:false
      }
    },
    mounted() {
      $(function (){
        $(document).on('mouseover mouseout','.qp',function (event){
          if(event.type=='mouseover'){
            $(this).find('.pop3').stop(true, true).slideDown(200)
            $(this).addClass('non')
          }else if(event.type == "mouseout"){
            $(this).find('.pop3').stop(true, true).slideUp(0)
            $(this).removeClass('non')
          }
        })
        $(document).on('mouseover mouseout','.pop3',function (event){
          if(event.type=='mouseover'){
            $(this).stop(true, true).slideDown(200)
            $(this).addClass('non')
          }else if(event.type == "mouseout"){
            $(this).stop(true, true).slideUp(0)
            $(this).removeClass('non')
          }
        })
      })
      window.CDEL.checkLogin((cb)=>{
        if(cb){
          this.iconUrl = cb.result.iconUrl
          this.isShowLogin = true
        }else{
          this.isShowLogin = false
        }
      })
      window.dialogUcLoginRegister.prototype.init()
    },
    methods:{
      logout(){
        window.CDEL.logout()
      }
    }
  }
</script>
<style lang="scss">
.header{
  box-sizing: content-box;
  width:1200px;
  margin:0 auto;
}
</style>
